module.exports = __webpack_public_path__ + "img/icon_four_top_2.cb01c6e8.png";